import { useEffect, useRef } from "react";

const useTabActivityMessage = (originalTitle = "Dashboard | Admin Panel") => {
  const intervalRef = useRef(null);

  var blinkMessage = "📌 Hey, still here?";
  var blinkInterval = 1500;

  useEffect(() => {
    const handleBlur = () => {
      let showOriginal = false;
      intervalRef.current = setInterval(() => {
        document.title = showOriginal ? originalTitle : blinkMessage;
        showOriginal = !showOriginal;
      }, blinkInterval);
    };

    const handleFocus = () => {
      clearInterval(intervalRef.current);
      document.title = originalTitle;
    };

    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      clearInterval(intervalRef.current);
    };
  }, [originalTitle, blinkMessage, blinkInterval]);
};

export default useTabActivityMessage;
